import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SuperLatexComponent } from '@examdojo/super-latex';
import { SuperLatexBlock } from '../../../model';

@Component({
  selector: 'dojo-superlatex-block-renderer',
  template: `<dojo-super-latex [content]="block()" />`,
  styles: `
    :host {
      @apply block my-4 text-lg;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SuperLatexComponent],
})
export class SuperLatexBlockRendererComponent {
  readonly block = input.required<SuperLatexBlock>();
}
